import React, { useState } from 'react';

import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';

import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';

//import { Image } from 'src/components/Antd';
import css from './css.less';
//import { removeFilter } from './store';
//import { useDispatch, useSelector } from 'react-redux';
import { ECustomTab, breadcrumbData, tabsConfig } from './InventoryListConfig';

import { useHistory } from 'react-router';

import { useI18n } from 'src/hooks/useRouterChange';
import { getActiveWarehouse } from 'src/request/common';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import AllList from './AllList';
import WarehouseList from './WarehouseList';

const InventoryList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canStock = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsStockIn,
        operation: EnumOperation.add_stock,
      }),
    ],
  });

  const history = useHistory();

  const [warehouses, setWarehouses] = React.useState([]);

  React.useEffect(() => {
    getActiveWarehouse().then(setWarehouses);
  }, []);

  //const dispatch = useDispatch();

  const [activeKey, setActiveKey] = useState(ECustomTab.All);

  // const exportFun = () => {
  //   console.log('Export');
  // };
  // const importFun = () => {
  //   console.log('Import');
  // };
  const addFun = () => {
    history.push('/stockEditor');
  };

  const tabChange = (activeKey) => {
    setActiveKey(activeKey);
    //dispatch(removeFilter());
  };

  const tabs = React.useMemo(() => {
    return tabsConfig(warehouses, { getI18n });
  }, [warehouses]);

  //console.log(warehouses.map((i) => i.locationName));

  const pageLayoutProps = {
    title: getI18n('inventory.inventory.list_general_pageLayoutProps_title'),
    //addButtonOverlay,
    addText: getI18n(
      'inventory.inventory.list_general_pageLayoutProps_addText',
    ),
    // exportFun,
    // importFun,
    addFun: canStock ? addFun : null,
    tabChange,
    tabsConfig: tabs,
  };

  const renderTable = () => {
    if (activeKey === ECustomTab.All) {
      return <AllList warehouses={warehouses} />;
    }
    return <WarehouseList warehouseUuid={activeKey} />;
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}></Breadcrumb>
      <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
        {renderTable()}
      </ListPageLayout>
    </React.Fragment>
  );
};

export default InventoryList;
